var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBroker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.519,
    height: 21.934,
    viewBox: "0 0 20.519 21.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "broker",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39171",
    "data-name": "Path 39171",
    d: "M19,21h.708v1.415H19Z",
    transform: "translate(-10.34 -12.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39172",
    "data-name": "Path 39172",
    d: "M29,21h.708v1.415H29Z",
    transform: "translate(-16.802 -12.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39173",
    "data-name": "Path 39173",
    d: "M23.538,28H22.83a1.061,1.061,0,0,1-2.123,0H20a1.769,1.769,0,0,0,3.538,0Z",
    transform: "translate(-10.986 -17.448)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39174",
    "data-name": "Path 39174",
    d: "M23.165,13.028h-.457A3.467,3.467,0,0,1,19.592,11.1a.369.369,0,0,0-.633,0,3.467,3.467,0,0,1-3.12,1.927h-.457a.354.354,0,0,0-.354.354v.694c0,.091.006.18.008.27l-2.131-.533v-.6a4.618,4.618,0,0,0,2.251-2.66h.225a1.412,1.412,0,0,0,.208-2.809l.431-.862a4.021,4.021,0,0,0,.422-1.788V5a4,4,0,0,0-4-4H9.12a4,4,0,0,0-4,4v.094A4.021,4.021,0,0,0,5.545,6.88l.431.862a1.412,1.412,0,0,0,.208,2.809h.225A4.618,4.618,0,0,0,8.66,13.212v.6l-3.249.814A3.178,3.178,0,0,0,3,17.714V22.58a.354.354,0,0,0,.354.354H18.212a.354.354,0,0,0,.354-.354V21.105c.168.124.34.244.518.358a.354.354,0,0,0,.38,0,8.715,8.715,0,0,0,4.055-7.387v-.694a.354.354,0,0,0-.354-.354ZM8.884,14.486,10.225,16.1l-1.372.686-.784-2.09Zm1.495,3.848h.808l.6,3.891H9.78Zm.856-.708h-.9l-.227-.68.679-.34.679.34Zm.106-1.532,1.341-1.609.814.2-.784,2.091Zm4.748-6.959a.708.708,0,0,1-.708.708h-.06a4.619,4.619,0,0,0,.06-.708V8.429A.708.708,0,0,1,16.089,9.137ZM5.83,5a3.29,3.29,0,0,1,3.29-3.29h3.325A3.29,3.29,0,0,1,15.736,5v.094a3.307,3.307,0,0,1-.347,1.472l-.106.208a.35.35,0,0,0-.254-.112,2.249,2.249,0,0,1-2.1-1.42l-.051-.127a.354.354,0,0,0-.657,0l-.051.127a2.248,2.248,0,0,1-2.1,1.42H6.538a.35.35,0,0,0-.256.112l-.1-.208A3.307,3.307,0,0,1,5.83,5.092Zm.354,4.847a.708.708,0,1,1,0-1.415v.708a4.619,4.619,0,0,0,.06.708Zm.708-.708V7.368h3.184a2.95,2.95,0,0,0,2.476-1.332,2.945,2.945,0,0,0,2.123,1.309V9.137a3.891,3.891,0,1,1-7.783,0Zm3.891,4.6a4.578,4.578,0,0,0,1.415-.225v.451l-1.415,1.7-1.415-1.7v-.451A4.578,4.578,0,0,0,10.783,13.736ZM3.708,17.714a2.472,2.472,0,0,1,1.875-2.4l1.8-.449.95,2.535a.354.354,0,0,0,.49.192l.646-.323.248.745-.647,4.214H6.184V19.042H5.476v3.184H3.708Zm14.151,4.512H16.089V19.042h-.708v3.184H12.5l-.648-4.214.248-.745.646.323a.354.354,0,0,0,.49-.192l.951-2.535.9.225a8.691,8.691,0,0,0,2.77,5.433Zm4.953-8.15a8.01,8.01,0,0,1-3.538,6.666,8.01,8.01,0,0,1-3.538-6.666v-.34h.1a4.166,4.166,0,0,0,3.434-1.785,4.166,4.166,0,0,0,3.434,1.785h.1Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39175",
    "data-name": "Path 39175",
    d: "M44.476,37a2.476,2.476,0,1,0,2.476,2.476A2.476,2.476,0,0,0,44.476,37Zm0,4.245a1.769,1.769,0,1,1,1.769-1.769A1.769,1.769,0,0,1,44.476,41.245Z",
    transform: "translate(-25.203 -23.264)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39176",
    "data-name": "Path 39176",
    d: "M47.415,41h-.708v.708H46v.708h.708v.708h.708v-.708h.708v-.708h-.708Z",
    transform: "translate(-27.788 -25.849)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroker);
export default __webpack_public_path__ + "static/media/broker.9519e06b.svg";
export { ForwardRef as ReactComponent };